import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import style from './style.scss';
import Product from 'components/partials/product';
import {Select} from 'components/partials/select';
import {connect} from 'react-redux';
import {Products} from 'api';
import {ShowIf} from 'components/utils';
import {NoContent} from 'components/no-content';
import {LoadingPage} from 'components/loading-page';

class ListProduct extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      count: 0,
      skip: 0,
      limit: 10,
      isLoading: false,
      searchProduct: '',
      productStatus: 1,
      category: {},
      status: [
        {status: 0, name: 'Sản phẩm đang đợi duyệt'},
        {status: 1, name: 'Sản phẩm đã duyệt'},
        {status: 2, name: 'Sản phẩm bị từ chối'}
      ]
    };
    this.loadMore = this.loadMore.bind(this);
    this.onChange = this.onChange.bind(this);
    this.searchProduct = this.searchProduct.bind(this);
    this.filterProductByStatus = this.filterProductByStatus.bind(this);
  }

  componentDidMount() {
    if (this.props.business) {
      let params = {
        where: {
          businessId: this.props.business.id,
          status: this.state.productStatus
        }
      };
      this.setState({isLoading: true});
      Products.actions.countProductByBusiness.request(params).then((response) => {
        this.setState({count: response.data.count});
        this.getList(this.props.business.id);
      }).catch(() => {
        this.setState({isLoading: false});
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.business && nextProps.business !== this.state.business) {
      this.setState({
        business: nextProps.business
      });

      this.getList(nextProps.business.id);
    }
  }

  getList(businessId) {
    this.setState({isLoading: true});

    let params = {
      filter: {
        limit: this.state.limit,
        skip: this.state.skip,
        where: {
          businessId,
          status: this.state.productStatus
        }
      }
    };

    if (this.state.searchProduct !== '') {
      params.filter.where.name = {
        like: this.state.searchProduct
      };
    }

    Products.actions.listByBusiness.request(params).then(response => {
      if (response && response.data) {
        let products = this.state.data || [];
        products = products.concat(response.data);

        this.setState({data: products, isLoading: false});
      }
    }).catch(() => {
      this.setState({isLoading: false});
    });
  }

  loadMore() {
    this.setState({skip: this.state.skip + 10}, () => {
      this.getList(this.props.business.id);
    });
  }

  reloadData() {
    let params = {
      dntBusinessId: 'dnt_' + this.props.business.id,
      status: this.state.productStatus
    };

    if (this.state.searchProduct !== '') {
      params.name = {
        like: this.state.searchProduct
      };
    }
    this.setState({isLoading: true});
    Products.actions.countProductByBusiness.request(params).then((response) => {
      this.setState({data: [], limit: 10, skip: 0, count: response.data.count}, () => {
        this.getList(this.props.business.id);
      });
    }).catch(() => {
      this.setState({isLoading: false});
    });
  }

  onChange(e) {
    this.setState({[e.target.name]: e.target.value});
  }

  searchProduct(e) {
    e.preventDefault();
    this.reloadData();
  }

  filterProductByStatus(status) {
    this.setState({productStatus: status.target.value}, () => {
      this.reloadData();
    });
  }

  render() {
    const {searchProduct, isLoading, productStatus} = this.state;
    return (
      <section className="my-business-list-product">
        <LoadingPage isShow={this.state.isLoading} />
        {/*<div className="search-container content-justify">
          <form className="search-content-left" onSubmit={this.searchProduct}>
            <input className="list-product-input-search" name="searchProduct" value={searchProduct} onChange={this.onChange} type="text" placeholder="Tìm tên sản phẩm..."/>
            <button className="list-product-btn-search" type="submit"><i className="fa fa-search"/>Tìm kiếm</button>
          </form>
        </div>*/}

        <h1 className='user-header'>{this.state.status[this.state.productStatus].name}</h1>

        <ShowIf condition={this.state.data.length > 0}>
          <div className="wrap-product-edit">
            {
              this.state.data.map((item,i) => {
                return (
                  <div className="product-wrap" key={i}>
                    <Product edit={true} {...item}
                      enableSendRequest={false}
                    />
                  </div>
                );
              })
            }
          </div>
        </ShowIf>
        <ShowIf condition={this.state.data.length == 0 && !this.state.isLoading}>
          <NoContent content='Không có sản phẩm nào' height={608}/>
        </ShowIf>
        <ShowIf condition={!this.state.isLoading && this.state.data.length > 0 && (this.state.skip + this.state.limit) < this.state.count}>
          <button className="btn-viewmore-product" onClick={this.loadMore}>
            <span className="btn-viewmore-text">Xem Thêm</span>
          </button>
        </ShowIf>
      </section>
    );
  }
}

const bindStateToProps = (state) => {
  let business = {};
  if (state.myBusinesses && state.myBusinesses.mainBusiness) {
    business = state.myBusinesses.mainBusiness;
  }

  return {
    auth: state.auth,
    business
  };
};

export default withRouter(connect(bindStateToProps)(ListProduct));



// WEBPACK FOOTER //
// ./components/my-business/list-product/ListProduct.jsx